import { CONSTANTS } from '../config/constants';
import Utils from '../lib/utils';

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('osm_search')) {
		W.mapFeatures = {};
		let minMax = {};

		let map = new mapboxgl.Map({
			container: 'osm_search_map',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});

		// Set the input as a comma separated string of osm_ids
		function setInput() {
			const keys_string = Object.values(W.mapFeatures)
				.map((item) => {
					return item.osm_id;
				})
				.join(', ');
			document.getElementById('from_osm_id').value = keys_string;
			document.getElementById('osm_id_display').innerHTML = keys_string;
		}

		function setMapBounds() {
			if (Object.keys(W.mapFeatures).length > 0) {
				let lnglat;
				Object.values(W.mapFeatures).forEach((feature) => {
					lnglat = feature.lnglat;
					let geojson = feature.geojson;

					// calculate min/max lat and lon across all objects
					if (geojson.type === 'Point') {
						lnglat = geojson.coordinates;
						minMax.xMin = minMax.xMin < lnglat[1] ? minMax.xMin : lnglat[1];
						minMax.xMax = minMax.xMax > lnglat[1] ? minMax.xMax : lnglat[1];
						minMax.yMin = minMax.yMin < lnglat[0] ? minMax.yMin : lnglat[0];
						minMax.yMax = minMax.yMax > lnglat[0] ? minMax.yMax : lnglat[0];
					} else {
						geojson.coordinates[0].forEach((lnglat) => {
							minMax.xMin = minMax.xMin < lnglat[1] ? minMax.xMin : lnglat[1];
							minMax.xMax = minMax.xMax > lnglat[1] ? minMax.xMax : lnglat[1];
							minMax.yMin = minMax.yMin < lnglat[0] ? minMax.yMin : lnglat[0];
							minMax.yMax = minMax.yMax > lnglat[0] ? minMax.yMax : lnglat[0];
						});
					}
				});

				map.fitBounds(
					[
						[minMax.yMin, minMax.xMin],
						[minMax.yMax, minMax.xMax],
					],
					{ padding: 50, maxZoom: 16 },
				);
			}
		}

		function removeFromMap(layerId) {
			// wait a bit so the map click does not add the feature again
			setTimeout(() => {
				map.removeLayer(layerId);
				delete W.mapFeatures[layerId];
				setInput();
				setMapBounds();
			}, 100);
		}

		// Add an object to the map
		function addToMap(feature) {
			const sourceId = 'osm-' + feature.osm_id + '-source';
			const layerId = 'osm-' + feature.osm_id + '-layer';

			if (!Object.keys(W.mapFeatures).includes(layerId)) {
				const featureType = feature.geojson.type === 'Polygon' ? 'fill' : 'symbol';

				let layoutOptions = {};
				if (featureType === 'symbol') {
					layoutOptions = {
						'icon-image': 'location-dot-00759b',
						'icon-offset': [0, 0],
						'icon-anchor': 'bottom',
						'icon-size': 1.5,
						'icon-allow-overlap': true,
						'icon-ignore-placement': true,
					};
				}

				let paintOptions = {};
				if (featureType === 'fill') {
					paintOptions = {
						'fill-color': '#c5050c',
					};
				}

				if (!map.getSource(sourceId)) {
					map.addSource(sourceId, {
						type: 'geojson',
						data: feature.geojson,
					});
				}
				map.addLayer(
					{
						id: layerId,
						type: featureType,
						source: sourceId,
						layout: layoutOptions,
						paint: paintOptions,
					},
					'uw-labels',
				);

				map.on('mouseenter', layerId, () => {
					map.getCanvas().style.cursor = 'pointer';
				});
				map.on('mouseleave', layerId, () => {
					map.getCanvas().style.cursor = '';
				});
				map.on('click', layerId, (e) => {
					removeFromMap(e.features[0].layer.id);
				});

				W.mapFeatures[layerId] = {
					lnglat: feature.lnglat,
					geojson: feature.geojson,
					osm_id: feature.osm_id,
					layerId: layerId,
				};
				setMapBounds();
				setInput();
			}
		}

		// Map Click handler
		const layerIds = [
			'uw-parking-underground',
			'uw-buildings',
			'uw-buildings-partial',
			'uw-parking-lots',
			'uw-natural-areas',
		];
		// handle cursor on hover of map objects
		map.on('mouseenter', layerIds, () => {
			map.getCanvas().style.cursor = 'pointer';
		});
		map.on('mouseleave', layerIds, () => {
			map.getCanvas().style.cursor = '';
		});
		map.on('click', layerIds, (e) => {
			console.log('CLICCKK');
			let url = W.root + 'admin/osm/polygon_contains?';
			const params = { lng: e.lngLat.lng, lat: e.lngLat.lat };
			const urlSearchParams = new URLSearchParams(params);
			url = url + urlSearchParams;

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((data) => {
					if (data.length > 0) {
						const feature = data[0];
						addToMap(feature);
					}
				});
		});

		// Block normal functionality of the osm search form
		const osmSearchForm = document.getElementById('osm_search_form');
		osmSearchForm.addEventListener('submit', (e) => {
			e.preventDefault();
		});

		const osmInput = document.getElementById('osm_search_input');

		function osmSearch(term) {
			let url = W.root + 'admin/osm/?';
			const params = { s: term };
			const urlSearchParams = new URLSearchParams(params);
			url = url + urlSearchParams;
			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(`HTTP error! Status: ${response.status}`);
					}
					return response.json();
				})
				.then((response) => {
					const resultsContainer = document.querySelector('.uw-search-results');
					resultsContainer.innerHTML = '';
					if (response.length) {
						resultsContainer.classList.add('show');
					} else {
						resultsContainer.classList.remove('show');
					}
					const ul = document.createElement('ul');

					response.forEach((item) => {
						const li = document.createElement('li');
						const name = item.name || 'unnamed';
						const button = document.createElement('button');
						button.setAttribute('tabindex', -1);
						button.dataset.geojson = JSON.stringify(item.geojson);
						button.dataset.osm_id = item.osm_id;
						button.dataset.lnglat = JSON.stringify(item.lnglat);
						button.addEventListener('click', (e) => {
							e.stopPropagation();
							e.preventDefault();
							let feature = {};
							feature.geojson = JSON.parse(e.target.dataset.geojson);
							feature.osm_id = e.target.dataset.osm_id;
							feature.lnglat = JSON.parse(e.target.dataset.lnglat);
							addToMap(feature);
							osmInput.value = '';
							osmInput.focus();
							resultsContainer.classList.remove('show');
							return false;
						});
						button.textContent = item.osm_id + ' (' + name + ' / ' + item.geojson.type + ')';
						li.classList.add('uw-search-results-item');
						li.append(button);
						ul.append(li);
					});
					resultsContainer.append(ul);

					const listItems = document.querySelectorAll('.uw-search-results-item button');

					let activeIndex = -1;
					document.addEventListener('keydown', (e) => {
						if (e.key === 'ArrowUp' && activeIndex > 0) {
							e.preventDefault();
							activeIndex--;
							listItems[activeIndex].focus();
						} else if (e.key === 'ArrowUp' && activeIndex === 0) {
							e.preventDefault();
							osmInput.focus();
						} else if (e.key === 'ArrowDown' && activeIndex < listItems.length - 1) {
							e.preventDefault();
							activeIndex++;
							listItems[activeIndex].focus();
						}
					});
				});
		}

		const debounceOsmSearch = Utils.debounce(() => {
			osmSearch(osmInput.value);
		}, 200);

		osmInput.addEventListener('keyup', debounceOsmSearch);

		if (osmInput.value) {
			osmSearch(osmInput.value);
		}
	}
});
